/**
 * Button-style single-select group.
 *
 * Extracted verbatim from the local copy in `NewJobScreen.tsx` so the ticket
 * form can reuse the exact jobs-side control instead of growing a second
 * implementation. `allowClear` is additive and defaults to off, so the existing
 * job-form call sites behave exactly as before.
 */
export default function RadioGroup({
  options,
  value,
  onChange,
  columns = 3,
  allowClear = false,
}: {
  options: readonly { value: string; label: string }[];
  value: string;
  onChange: (v: string) => void;
  columns?: number;
  /** When true, clicking the selected option deselects it (for optional fields). */
  allowClear?: boolean;
}) {
  return (
    <div className={`grid gap-2`} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
      {options.map((opt) => {
        const selected = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(selected && allowClear ? '' : opt.value)}
            className={`px-3 py-2.5 rounded-lg border text-sm font-medium transition-colors ${
              selected
                ? 'border-fieldiq-accent text-fieldiq-accent bg-amber-500/10'
                : 'border-fieldiq-border text-white bg-fieldiq-card hover:border-fieldiq-accent'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
